import { Mark, mergeAttributes } from '@tiptap/core';

import { SemanticColor } from '../../utils';

export interface SemanticColorOptions {
  HTMLAttributes: Record<string, unknown>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    semanticColor: {
      setSemanticColor: (color: SemanticColor) => ReturnType;
      unsetSemanticColor: () => ReturnType;
    };
  }
}

export const SemanticColorMark = Mark.create<SemanticColorOptions>({
  name: 'semanticColor',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      color: {
        default: null,
        parseHTML: element => element.getAttribute('data-semantic-color'),
        renderHTML: attributes => {
          if (!attributes.color) {
            return {};
          }
          return { 'data-semantic-color': attributes.color };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-semantic-color]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ];
  },

  addCommands() {
    return {
      setSemanticColor:
        (color: SemanticColor) =>
        ({ commands }) => {
          return commands.setMark(this.name, { color });
        },
      unsetSemanticColor:
        () =>
        ({ commands }) => {
          return commands.unsetMark(this.name);
        },
    };
  },
});
